var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36054 2.64375C1.36054 1.17226 2.47667 0 3.82993 0H4.17007C5.52333 0 6.63946 1.17226 6.63946 2.64375V3.00625C6.63946 3.95146 6.17893 4.7732 5.49085 5.24009C6.9383 5.71321 8 7.15069 8 8.86667C8 9.50398 7.51839 10 6.94785 10H1.05215C0.48161 10 0 9.50397 0 8.86667C0 7.15069 1.0617 5.7132 2.50915 5.24009C1.82107 4.7732 1.36054 3.95146 1.36054 3.00625V2.64375ZM3.82993 0.9375C2.92897 0.9375 2.21769 1.7128 2.21769 2.64375V3.00625C2.21769 3.9372 2.92897 4.7125 3.82993 4.7125H4.17007C5.07103 4.7125 5.78231 3.9372 5.78231 3.00625V2.64375C5.78231 1.7128 5.07103 0.9375 4.17007 0.9375H3.82993ZM3.54649 6.0125C2.05066 6.0125 0.857143 7.30174 0.857143 8.86667C0.857143 8.96344 0.933908 9.0625 1.05215 9.0625H6.94785C7.06609 9.0625 7.14286 8.96344 7.14286 8.86667C7.14286 7.30174 5.94934 6.0125 4.45352 6.0125H3.54649Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Personal.61d77bf0d55434f60681b17b81b823a9.svg";